<template>
	<TheTable
		v-if="tableData"
		:tableData="tableData"
		:loading="loading"
		:defaultSort="{ prop: 'createdDate', order: 'descending' }"
		:showMaxRows="14"
		@rowClick="goToDetailPage"
		@rowClickNewTab="goToDetailPageNewTab"
		:mobileBox="mobileBox"
	>
		<template #box>
			<BoxComplaint v-for="item in tableData" :key="item.hid" :complaint="item" />
		</template>

		<el-table-column prop="state" label="Status" width="120" sortable>
			<template #default="scope">
				<div class="has-status" :class="`has-status--${$getStateColor('complaint', scope.row.state)}`">
					{{ $getStateFullLabel('complaint', scope.row.state) }}
				</div>
			</template>
		</el-table-column>
		<el-table-column prop="hid" label="ID" width="80" sortable />
		<el-table-column prop="" label="Datum" width="100" sortable>
			<template #default="scope">
				<span>{{ $formatDate(scope.row.createdDate) }}</span>
			</template>
		</el-table-column>
		<el-table-column prop="title" label="Titel" min-width="120" sortable :sort-method="(a, b) => $sortAlphabetically(a, b, 'title')" />
		<el-table-column prop="medium.name" label="Medium" width="130" sortable />
		<el-table-column prop="" label="Anhang" width="100" sortable :sort-method="$sortAttachments">
			<template #default="scope">
				<el-icon v-if="scope.row.files.length > 0 || scope.row.links.length > 0"><Paperclip /></el-icon>
				<span v-else>-</span>
			</template>
		</el-table-column>
		<el-table-column prop="" label="Kategorie" width="150" sortable>
			<template #default="scope">
				<span v-if="scope.row.category">{{ $recursivelyFindCategoryName(scope.row.category.number) }}</span>
				<span v-else>-</span>
			</template>
		</el-table-column>
		<el-table-column prop="email" label="E-Mail" width="160" sortable v-if="shouldSeePersonalData" />
		<el-table-column prop="" label="Datum Entsch." width="140" sortable>
			<template #default="scope">
				<span v-if="scope.row.decidedDate">{{ $formatDate(scope.row.decidedDate) }}</span>
				<span v-else>-</span>
			</template>
		</el-table-column>
		<el-table-column prop="publishedDate" label="Freigabe" width="100" sortable>
			<template #default="scope">
				<span v-if="scope.row.publishedDate">Ja</span>
				<span v-else>Nein</span>
			</template>
		</el-table-column>
	</TheTable>

	<TablePagination :currentLength="tableData.length" :totalMaxVal="totalCount" @loadNextPage="$emit('loadNextPage')" />
</template>

<script lang="ts">
import { Paperclip } from '@element-plus/icons-vue';
import { defineComponent, PropType } from 'vue';
import { ComplaintResponse } from '../../types/types';
import BoxComplaint from '../boxes/BoxComplaint.vue';
import TheTable from '../TheTable.vue';
import TablePagination from './TablePagination.vue';

export default defineComponent({
	name: 'ComplaintsTable',
	components: {
		Paperclip,
		TablePagination,
		TheTable,
		BoxComplaint,
	},
	props: {
		tableData: {
			type: Array as PropType<ComplaintResponse[]>,
			default: [],
			required: true,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		totalCount: {
			type: Number,
			default: 0,
		},
		shouldSeePersonalData: {
			type: Boolean,
			default: true,
		},
		mobileBox: {
			type: Boolean,
			default: false,
		},
		isDummy: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {};
	},
	emits: ['loadNextPage'],
	methods: {
		goToDetailPage(row: ComplaintResponse) {
			if (this.isDummy) return;
			this.$router.push({ name: 'BeschwerdeDetail', params: { id: String(row.id) } });
		},
		goToDetailPageNewTab(row: ComplaintResponse) {
			if (this.isDummy) return;
			window.open(this.$router.resolve({ name: 'BeschwerdeDetail', params: { id: String(row.id) } }).href, '_blank');
		},
	},
});
</script>

<style lang="scss"></style>
